export default __webpack_public_path__ + "static/media/13_128gb_do.1ab02de8.jpg";